export function capitalize(s) {
  const filterString = s?.replace(/\//g, '');
  return filterString?.length > 0 ? filterString[0]?.toUpperCase() + filterString?.slice(1) : '';
}

export function getBreadCrumbsList(page, landings) {
  const list = [
    {
      slug: '/',
      name: 'Home',
    },
    {
      slug: '/fonts',
      name: 'Fonts',
    },
  ];
  if (page && landings) {
    const getLandingName = landings.filter(item => {
      return `${item.slug}` === `fonts/${page}`;
    });
    if (getLandingName.length > 0) {
      list.push(getLandingName[0]);
    }
  }
  return list;
}
